module.exports = __webpack_public_path__ + "static/WriteAStory-dbc728eb285804f551c797582e95ca9a.pdf";